import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import {
  DebtorAccountHistoryWidgetComponent
} from "@feature/_app_modules/debtor-account-history-widget/containers/debtor-account-history-widget-containers/debtor-account-history-widget.component";
import {
  DebtorAccountHistoryWidgetSelectionComponentModule
} from "@feature/_app_modules/debtor-account-history-widget/debtor-account-history-widget-selection-component.module";
import {
  DebtorAccountHistoryWidgetPrintLayoutComponent
} from "@feature/_app_modules/debtor-account-history-widget/components/print-layout/debtor-account-history-widget-print-layout.component";

@NgModule({
  declarations: [
    DebtorAccountHistoryWidgetComponent,
    DebtorAccountHistoryWidgetPrintLayoutComponent,
  ],
  exports: [
    DebtorAccountHistoryWidgetComponent,
    DebtorAccountHistoryWidgetSelectionComponentModule,
    DebtorAccountHistoryWidgetPrintLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DebtorAccountHistoryWidgetSelectionComponentModule
  ],
  providers: []
})
export class DebtorAccountHistoryWidgetModule { }
